// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Full-page layout ===== */
.LoginModal-pageWrapper-nhhTe {
	position: relative;
	width: 100%;
	height: 100vh;
	height: 100dvh;
	max-height: 100vh;
	max-height: 100dvh;
	background: -webkit-gradient(linear, left top, left bottom, from(#FFFFFF), to(#ABE4FF));
	background: linear-gradient(180deg, #FFFFFF 0%, #ABE4FF 100%);
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	overflow-y: auto;
	overflow-x: hidden;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
	/* padding: 10px 24px 8px; */
}
/* ===== Top logo ===== */
.LoginModal-primaryLogo-lRECJ {
	position: absolute;
	top: 14px;
	left: 28px;
	height: 46px;
	width: 124px;
	z-index: 10;
	cursor: pointer;
}
/* ===== Main content area (two columns) ===== */
.LoginModal-mainContent-uqB4E {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	/* padding: 15px 16px 6px; */
	gap: clamp(152px, 3.5vw, 50px);
	max-width: 1900px;
	margin: 0 auto;
	width: 100%;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
}
/* ===== Left column ===== */
.LoginModal-leftColumn-kcDXi {
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
	max-width: 520px;
}
.LoginModal-welcomeTitle-UMxe0 {
	font-family: var(--font-family-base) !important;
	font-weight: 700;
	font-size: clamp(30px, 3.6vw, 50px);
	line-height: 1.1s;
	color: var(--secondary-oscuro);
	margin: 0 0 8px;
}
.LoginModal-welcomeTitleAccent-dig_w {
	color: var(--color-gradient-top);
}
.LoginModal-welcomeSubtitle-Y1CHY {
	font-family: var(--font-family-base) !important;
	font-weight: 400;
	font-size: clamp(16px, 1.7vw, 22px);
	line-height: 1.3;
	color: var(--secondary-oscuro);
	margin: 0 0 24px;
	max-width: 500px;
}
/* ===== Feature items ===== */
.LoginModal-featuresList-kgvFN {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	gap: clamp(12px, 1.8vh, 20px);
	margin-bottom: 0;
}
.LoginModal-featureItem-AvQWd {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 16px;
}
.LoginModal-featureIconCircle-LbFl6 {
	width: clamp(54px, 4.6vw, 79px);
	height: clamp(54px, 4.6vw, 79px);
	min-width: clamp(54px, 4.6vw, 79px);
	border-radius: 50%;
	background: #FFFFFF;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-shadow: 0px 2px 8px rgba(0, 52, 83, 0.1);
	        box-shadow: 0px 2px 8px rgba(0, 52, 83, 0.1);
}
.LoginModal-featureIconCircle-LbFl6 svg,
.LoginModal-featureIconCircle-LbFl6 img {
	width: clamp(28px, 2.4vw, 40px);
	height: clamp(28px, 2.4vw, 40px);
	-o-object-fit: contain;
	   object-fit: contain;
}
.LoginModal-featureTextGroup-SBMV8 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
}
.LoginModal-featureTitle-dy74p {
	font-family: var(--font-family-base) !important;
	font-weight: 700;
	font-size: clamp(16px, 1.35vw, 20px);
	line-height: clamp(20px, 1.6vw, 28px);
	color: var(--secondary-oscuro);
	margin: 0;
}
.LoginModal-featureDesc-Ovj2C {
	font-family: var(--font-family-base) !important;
	font-weight: 400;
	font-size: clamp(14px, 1.15vw, 16px);
	line-height: clamp(17px, 1.3vw, 23px);
	color: var(--secondary-oscuro);
	margin: 0;
}
/* ===== Right column (login card) ===== */
.LoginModal-rightColumn-MtBGT {
	-webkit-box-flex: 0;
	    -ms-flex: 0 0 auto;
	        flex: 0 0 auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}
.LoginModal-root-QOU0j {
	width: clamp(340px, 28vw, 512px);
	max-width: 100%;
	background: #FFFFFF;
	border: 1px solid #FFFFFF;
	-webkit-box-shadow: 0px 4px 4px 5px rgba(0, 0, 0, 0.25);
	        box-shadow: 0px 4px 4px 5px rgba(0, 0, 0, 0.25);
	border-radius: 35px;
	padding: 20px 32px 18px;
	position: relative;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
}
.LoginModal-closeBtn-LBjEU {
	position: absolute;
	top: 12px;
	right: 14px;
	width: 26px;
	height: 26px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	font-size: 20px;
	font-weight: 300;
	color: var(--secondary-oscuro);
	cursor: pointer;
	opacity: 0.7;
	-webkit-transition: opacity 0.2s ease;
	transition: opacity 0.2s ease;
	text-decoration: none;
	line-height: 1;
	z-index: 10;
	border-radius: 50%;
	background: #FFFFFF;
}
.LoginModal-closeBtn-LBjEU:hover,
.LoginModal-closeBtn-LBjEU:focus,
.LoginModal-closeBtn-LBjEU:active {
	opacity: 1;
	text-decoration: none;
	color: var(--secondary-oscuro);
}
.LoginModal-closeBtn-LBjEU span {
	position: relative;
	top: -1px;
}
/* ===== Card header (icon + title) ===== */
.LoginModal-cardHeader-XmZ3u {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	margin-bottom: 12px;
}
.LoginModal-cardIconWrapper-nWohp {
	/* margin-bottom: 4px; */
}
.LoginModal-cardIconWrapper-nWohp img {
	width: 48px;
	height: 69px;
}
.LoginModal-cardTitle-gv9Lk {
	font-family: var(--font-family-base) !important;
	font-weight: bold;
	font-size: clamp(26px, 2.3vw, 28px);
	line-height: 1.1;
	color: var(--color-gradient-top);
	margin: 0 0 0px;
	text-align: center;
}
.LoginModal-cardSubtitle-xKZe6 {
	font-family: var(--font-family-base) !important;
	font-weight: 400;
	font-size: 16px;
	line-height: 19px;
	color: var(--secondary-oscuro);
	text-align: center;
	max-width: 300px;
	margin: 10px auto;
}
/* ===== Divider line ("o continuar con") ===== */
.LoginModal-lineThrough-GwwzN {
	font-size: 20px;
	font-family: var(--font-family-base);
	line-height: 23px;
	font-weight: 400;
	text-align: center;
	position: relative;
	margin: 12px 0 12px;
}
.LoginModal-linetext-yiXO4 {
	color: var(--secondary-oscuro);
	font-size: 14px;
	font-family: var(--font-family-base);
	line-height: 23px;
	position: relative;
	display: inline-block;
	background: #FFFFFF;
	padding: 0 10px;
	z-index: 1;
}
.LoginModal-lineThrough-GwwzN::before {
	content: '';
	position: absolute;
	top: 50%;
	left: 0;
	right: 0;
	height: 1px;
	background-color: #8E8E93;
	z-index: 0;
}
/* ===== Bottom links ===== */
.LoginModal-linkText-I9vtK {
	font-size: 14px;
	font-family: var(--font-family-base);
	line-height: 23px;
	font-weight: 400;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	gap: 8px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	margin-bottom: 0px;
	margin-top: 12px;
	color: var(--secondary-oscuro);
}
.LoginModal-modalCaptionLink-SpyYZ,
.LoginModal-modalCaptionLink-SpyYZ:hover,
.LoginModal-modalCaptionLink-SpyYZ:focus,
.LoginModal-modalCaptionLink-SpyYZ:active {
	color: var(--color-gradient-top);
	font-size: 14px;
	font-family: var(--font-family-base);
	font-weight: 700;
	cursor: pointer;
	text-decoration: none;
}
/* ===== Bottom app banner ===== */
.LoginModal-appBanner-ulzRT {
	width: 100%;
	max-width: 1199px;
	margin: 0px auto 40px;
	background: var(--color-gradient-top);
	border: 1px solid var(--color-gradient-top);
	border-radius: 19px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	padding: clamp(12px, 2vh, 26px) 34px;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
	position: relative;
	overflow: visible;
	min-height: clamp(74px, 8vh, 118px);
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}
.LoginModal-appBannerLeft-UZPtN {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 24px;
	position: relative;
	z-index: 2;
	padding-left: clamp(150px, 12vw, 185px);
}
.LoginModal-phoneMockup-BJiz_ {
	position: absolute;
	left: 0px;
	bottom: -35px;
	height: clamp(180px, 13vh, 168px);
	width: 135px;
	-o-object-fit: cover;
	   object-fit: cover;
	-o-object-position: top;
	   object-position: top;
	-webkit-filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.15));
	        filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.15));
	border-radius: 30px 30px 0px 0px;
	clip-path: inset(0px 4px 0px 4px);
}
.LoginModal-appBannerTextGroup-HqlyK {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
}
.LoginModal-appBannerTitle-M8wNT {
	font-family: var(--font-family-base);
	font-weight: 700;
	font-size: clamp(16px, 1.35vw, 24px);
	line-height: clamp(19px, 1.6vw, 28px);
	color: #FFFFFF;
	margin: 0 0 4px;
}
.LoginModal-appBannerDesc-PyuJx {
	font-family: var(--font-family-base);
	font-weight: 400;
	font-size: clamp(12px, 1vw, 16px);
	line-height: clamp(15px, 1.2vw, 19px);
	color: #FFFFFF;
	margin: 0;
	max-width: 300px;
}
.LoginModal-appBannerRight-jFd_u {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	gap: 16px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	z-index: 2;
}
.LoginModal-storeIcon-KUVO9 {
	height: clamp(47px, 3.4vh, 47px);
	width: auto;
	-o-object-fit: contain;
	   object-fit: contain;
	cursor: pointer;
	-webkit-transition: opacity 0.2s ease;
	transition: opacity 0.2s ease;
}
.LoginModal-storeIcon-KUVO9:hover {
	opacity: 0.85;
}
/* ===== Hidden / unused classes (kept for compat) ===== */
.LoginModal-logoTopContainer-whXsN {
	display: none;
}
.LoginModal-logoTop-m7U7j {
	display: none;
}
.LoginModal-contentWrapper-G37eS {
	display: none;
}
.LoginModal-welcomeSection-SMPpy {
	display: none;
}
.LoginModal-logoImage-suN63 {
	display: none;
}
.LoginModal-appStoreSection-blys4 {
	display: none;
}
.LoginModal-appStoreText-GrYOV {
	display: none;
}
.LoginModal-appStoreIcons-m319z {
	display: none;
}
.LoginModal-iconPosition-gTHqL {
	position: absolute;
	top: 15px;
	right: 10px;
}
/* ===== Responsive ===== */
@media screen and (max-width: 1024px) {
	.LoginModal-pageWrapper-nhhTe {
		height: auto;
		min-height: 100vh;
		min-height: 100dvh;
		max-height: none;
	}

	.LoginModal-mainContent-uqB4E {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
		padding: 60px 16px 20px;
		gap: 24px;
	}

	.LoginModal-leftColumn-kcDXi {
		max-width: 100%;
		text-align: center;
	}

	.LoginModal-welcomeSubtitle-Y1CHY {
		margin-left: auto;
		margin-right: auto;
	}

	.LoginModal-featuresList-kgvFN {
		-webkit-box-align: center;
		    -ms-flex-align: center;
		        align-items: center;
	}

	.LoginModal-featureItem-AvQWd {
		text-align: left;
	}

	.LoginModal-rightColumn-MtBGT {
		width: 100%;
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
	}

	.LoginModal-appBanner-ulzRT {
		margin-left: 16px;
		margin-right: 16px;
		width: calc(100% - 32px);
		max-width: calc(100% - 32px);
	}
}
@media screen and (max-width: 767px) {
	.LoginModal-primaryLogo-lRECJ {
		left: 14px;
		top: 14px;
		height: 30px;
	}

	.LoginModal-mainContent-uqB4E {
		padding: 55px 12px 16px;
		gap: 20px;
	}

	.LoginModal-welcomeTitle-UMxe0 {
		font-size: 28px;
	}

	.LoginModal-welcomeSubtitle-Y1CHY {
		font-size: 15px;
		line-height: 20px;
	}

	.LoginModal-featuresList-kgvFN {
		gap: 12px;
		margin-bottom: 16px;
	}

	.LoginModal-root-QOU0j {
		width: 100%;
		max-width: 480px;
		padding: 20px 24px 18px;
		border-radius: 24px;
	}

	.LoginModal-appBanner-ulzRT {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
		text-align: center;
		padding: 14px 14px 120px;
		margin-left: 12px;
		margin-right: 12px;
		width: calc(100% - 24px);
		max-width: calc(100% - 24px);
	}

	.LoginModal-appBannerLeft-UZPtN {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
		gap: 8px;
		padding-left: 0;
	}

	.LoginModal-phoneMockup-BJiz_ {
		left: 50%;
		-webkit-transform: translateX(-50%);
		    -ms-transform: translateX(-50%);
		        transform: translateX(-50%);
		bottom: -6px;
		height: 112px;
		margin-top: 0;
		margin-bottom: 0;
	}

	.LoginModal-appBannerRight-jFd_u {
		margin-top: 10px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/LoginModal/LoginModal.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;CACC,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,uFAA6D;CAA7D,6DAA6D;CAC7D,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,gBAAgB;CAChB,kBAAkB;CAClB,8BAAsB;SAAtB,sBAAsB;CACtB,4BAA4B;AAC7B;AAEA,yBAAyB;AACzB;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,YAAY;CACZ,YAAY;CACZ,WAAW;CACX,eAAe;AAChB;AAEA,gDAAgD;AAChD;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,mBAAO;KAAP,aAAO;SAAP,SAAO;CACP,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,4BAA4B;CAC5B,8BAA8B;CAC9B,iBAAiB;CACjB,cAAc;CACd,WAAW;CACX,8BAAsB;SAAtB,sBAAsB;AACvB;AAEA,4BAA4B;AAC5B;CACC,mBAAO;KAAP,aAAO;SAAP,SAAO;CACP,gBAAgB;AACjB;AAEA;CACC,+CAA+C;CAC/C,gBAAgB;CAChB,mCAAmC;CACnC,iBAAiB;CACjB,8BAA8B;CAC9B,eAAe;AAChB;AAEA;CACC,gCAAgC;AACjC;AAEA;CACC,+CAA+C;CAC/C,gBAAgB;CAChB,mCAAmC;CACnC,gBAAgB;CAChB,8BAA8B;CAC9B,gBAAgB;CAChB,gBAAgB;AACjB;AAEA,8BAA8B;AAC9B;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,6BAA6B;CAC7B,gBAAgB;AACjB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;AAEA;CACC,+BAA+B;CAC/B,gCAAgC;CAChC,mCAAmC;CACnC,kBAAkB;CAClB,mBAAmB;CACnB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,oDAA4C;SAA5C,4CAA4C;AAC7C;AAEA;;CAEC,+BAA+B;CAC/B,gCAAgC;CAChC,sBAAmB;IAAnB,mBAAmB;AACpB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;AACvB;AAEA;CACC,+CAA+C;CAC/C,gBAAgB;CAChB,oCAAoC;CACpC,qCAAqC;CACrC,8BAA8B;CAC9B,SAAS;AACV;AAEA;CACC,+CAA+C;CAC/C,gBAAgB;CAChB,oCAAoC;CACpC,qCAAqC;CACrC,8BAA8B;CAC9B,SAAS;AACV;AAEA,0CAA0C;AAC1C;CACC,mBAAc;KAAd,kBAAc;SAAd,cAAc;CACd,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;AAEA;CACC,gCAAgC;CAChC,eAAe;CACf,mBAAmB;CACnB,yBAAyB;CACzB,uDAA+C;SAA/C,+CAA+C;CAC/C,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,8BAAsB;SAAtB,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,WAAW;CACX,YAAY;CACZ,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,8BAA8B;CAC9B,eAAe;CACf,YAAY;CACZ,qCAA6B;CAA7B,6BAA6B;CAC7B,qBAAqB;CACrB,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,mBAAmB;AACpB;AAEA;;;CAGC,UAAU;CACV,qBAAqB;CACrB,8BAA8B;AAC/B;AAEA;CACC,kBAAkB;CAClB,SAAS;AACV;AAEA,2CAA2C;AAC3C;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,wBAAwB;AACzB;AAEA;CACC,WAAW;CACX,YAAY;AACb;AAEA;CACC,+CAA+C;CAC/C,iBAAiB;CACjB,mCAAmC;CACnC,gBAAgB;CAChB,gCAAgC;CAChC,eAAe;CACf,kBAAkB;AACnB;AAEA;CACC,+CAA+C;CAC/C,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,8BAA8B;CAC9B,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;AAEA,iDAAiD;AACjD;CACC,eAAe;CACf,oCAAoC;CACpC,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;AACpB;AAEA;CACC,8BAA8B;CAC9B,eAAe;CACf,oCAAoC;CACpC,iBAAiB;CACjB,kBAAkB;CAClB,qBAAqB;CACrB,mBAAmB;CACnB,eAAe;CACf,UAAU;AACX;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,QAAQ;CACR,WAAW;CACX,yBAAyB;CACzB,UAAU;AACX;AAEA,6BAA6B;AAC7B;CACC,eAAe;CACf,oCAAoC;CACpC,iBAAiB;CACjB,gBAAgB;CAChB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,QAAQ;CACR,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,kBAAkB;CAClB,gBAAgB;CAChB,8BAA8B;AAC/B;AAEA;;;;CAIC,gCAAgC;CAChC,eAAe;CACf,oCAAoC;CACpC,gBAAgB;CAChB,eAAe;CACf,qBAAqB;AACtB;AAEA,kCAAkC;AAClC;CACC,WAAW;CACX,iBAAiB;CACjB,qBAAqB;CACrB,qCAAqC;CACrC,2CAA2C;CAC3C,mBAAmB;CACnB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,oCAAoC;CACpC,8BAAsB;SAAtB,sBAAsB;CACtB,kBAAkB;CAClB,iBAAiB;CACjB,mCAAmC;CACnC,oBAAc;KAAd,cAAc;AACf;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,kBAAkB;CAClB,UAAU;CACV,uCAAuC;AACxC;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,aAAa;CACb,iCAAiC;CACjC,YAAY;CACZ,oBAAiB;IAAjB,iBAAiB;CACjB,uBAAoB;IAApB,oBAAoB;CACpB,6DAAqD;SAArD,qDAAqD;CACrD,gCAAgC;CAChC,iCAAiC;AAClC;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;AACvB;AAEA;CACC,oCAAoC;CACpC,gBAAgB;CAChB,oCAAoC;CACpC,qCAAqC;CACrC,cAAc;CACd,eAAe;AAChB;AAEA;CACC,oCAAoC;CACpC,gBAAgB;CAChB,iCAAiC;CACjC,qCAAqC;CACrC,cAAc;CACd,SAAS;CACT,gBAAgB;AACjB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,SAAS;CACT,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,UAAU;AACX;AAEA;CACC,gCAAgC;CAChC,WAAW;CACX,sBAAmB;IAAnB,mBAAmB;CACnB,eAAe;CACf,qCAA6B;CAA7B,6BAA6B;AAC9B;AAEA;CACC,aAAa;AACd;AAEA,0DAA0D;AAC1D;CACC,aAAa;AACd;AAEA;CACC,aAAa;AACd;AAEA;CACC,aAAa;AACd;AAEA;CACC,aAAa;AACd;AAEA;CACC,aAAa;AACd;AAEA;CACC,aAAa;AACd;AAEA;CACC,aAAa;AACd;AAEA;CACC,aAAa;AACd;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;AAEA,2BAA2B;AAC3B;CACC;EACC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;CACjB;;CAEA;EACC,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;CACV;;CAEA;EACC,eAAe;EACf,kBAAkB;CACnB;;CAEA;EACC,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;EACC,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;;CAEA;EACC,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,4BAA4B;CAC7B;AACD;AAEA;CACC;EACC,UAAU;EACV,SAAS;EACT,YAAY;CACb;;CAEA;EACC,uBAAuB;EACvB,SAAS;CACV;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,SAAS;EACT,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;CACpB;;CAEA;EACC,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,4BAA4B;CAC7B;;CAEA;EACC,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;EACR,eAAe;CAChB;;CAEA;EACC,SAAS;EACT,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;AACD","sourcesContent":["/* ===== Full-page layout ===== */\n.pageWrapper {\n\tposition: relative;\n\twidth: 100%;\n\theight: 100vh;\n\theight: 100dvh;\n\tmax-height: 100vh;\n\tmax-height: 100dvh;\n\tbackground: linear-gradient(180deg, #FFFFFF 0%, #ABE4FF 100%);\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tbox-sizing: border-box;\n\t/* padding: 10px 24px 8px; */\n}\n\n/* ===== Top logo ===== */\n.primaryLogo {\n\tposition: absolute;\n\ttop: 14px;\n\tleft: 28px;\n\theight: 46px;\n\twidth: 124px;\n\tz-index: 10;\n\tcursor: pointer;\n}\n\n/* ===== Main content area (two columns) ===== */\n.mainContent {\n\tdisplay: flex;\n\tflex: 1;\n\talign-items: center;\n\tjustify-content: center;\n\t/* padding: 15px 16px 6px; */\n\tgap: clamp(152px, 3.5vw, 50px);\n\tmax-width: 1900px;\n\tmargin: 0 auto;\n\twidth: 100%;\n\tbox-sizing: border-box;\n}\n\n/* ===== Left column ===== */\n.leftColumn {\n\tflex: 1;\n\tmax-width: 520px;\n}\n\n.welcomeTitle {\n\tfont-family: var(--font-family-base) !important;\n\tfont-weight: 700;\n\tfont-size: clamp(30px, 3.6vw, 50px);\n\tline-height: 1.1s;\n\tcolor: var(--secondary-oscuro);\n\tmargin: 0 0 8px;\n}\n\n.welcomeTitleAccent {\n\tcolor: var(--color-gradient-top);\n}\n\n.welcomeSubtitle {\n\tfont-family: var(--font-family-base) !important;\n\tfont-weight: 400;\n\tfont-size: clamp(16px, 1.7vw, 22px);\n\tline-height: 1.3;\n\tcolor: var(--secondary-oscuro);\n\tmargin: 0 0 24px;\n\tmax-width: 500px;\n}\n\n/* ===== Feature items ===== */\n.featuresList {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: clamp(12px, 1.8vh, 20px);\n\tmargin-bottom: 0;\n}\n\n.featureItem {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 16px;\n}\n\n.featureIconCircle {\n\twidth: clamp(54px, 4.6vw, 79px);\n\theight: clamp(54px, 4.6vw, 79px);\n\tmin-width: clamp(54px, 4.6vw, 79px);\n\tborder-radius: 50%;\n\tbackground: #FFFFFF;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbox-shadow: 0px 2px 8px rgba(0, 52, 83, 0.1);\n}\n\n.featureIconCircle svg,\n.featureIconCircle img {\n\twidth: clamp(28px, 2.4vw, 40px);\n\theight: clamp(28px, 2.4vw, 40px);\n\tobject-fit: contain;\n}\n\n.featureTextGroup {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.featureTitle {\n\tfont-family: var(--font-family-base) !important;\n\tfont-weight: 700;\n\tfont-size: clamp(16px, 1.35vw, 20px);\n\tline-height: clamp(20px, 1.6vw, 28px);\n\tcolor: var(--secondary-oscuro);\n\tmargin: 0;\n}\n\n.featureDesc {\n\tfont-family: var(--font-family-base) !important;\n\tfont-weight: 400;\n\tfont-size: clamp(14px, 1.15vw, 16px);\n\tline-height: clamp(17px, 1.3vw, 23px);\n\tcolor: var(--secondary-oscuro);\n\tmargin: 0;\n}\n\n/* ===== Right column (login card) ===== */\n.rightColumn {\n\tflex: 0 0 auto;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.root {\n\twidth: clamp(340px, 28vw, 512px);\n\tmax-width: 100%;\n\tbackground: #FFFFFF;\n\tborder: 1px solid #FFFFFF;\n\tbox-shadow: 0px 4px 4px 5px rgba(0, 0, 0, 0.25);\n\tborder-radius: 35px;\n\tpadding: 20px 32px 18px;\n\tposition: relative;\n\tbox-sizing: border-box;\n}\n\n.closeBtn {\n\tposition: absolute;\n\ttop: 12px;\n\tright: 14px;\n\twidth: 26px;\n\theight: 26px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 20px;\n\tfont-weight: 300;\n\tcolor: var(--secondary-oscuro);\n\tcursor: pointer;\n\topacity: 0.7;\n\ttransition: opacity 0.2s ease;\n\ttext-decoration: none;\n\tline-height: 1;\n\tz-index: 10;\n\tborder-radius: 50%;\n\tbackground: #FFFFFF;\n}\n\n.closeBtn:hover,\n.closeBtn:focus,\n.closeBtn:active {\n\topacity: 1;\n\ttext-decoration: none;\n\tcolor: var(--secondary-oscuro);\n}\n\n.closeBtn span {\n\tposition: relative;\n\ttop: -1px;\n}\n\n/* ===== Card header (icon + title) ===== */\n.cardHeader {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tmargin-bottom: 12px;\n}\n\n.cardIconWrapper {\n\t/* margin-bottom: 4px; */\n}\n\n.cardIconWrapper img {\n\twidth: 48px;\n\theight: 69px;\n}\n\n.cardTitle {\n\tfont-family: var(--font-family-base) !important;\n\tfont-weight: bold;\n\tfont-size: clamp(26px, 2.3vw, 28px);\n\tline-height: 1.1;\n\tcolor: var(--color-gradient-top);\n\tmargin: 0 0 0px;\n\ttext-align: center;\n}\n\n.cardSubtitle {\n\tfont-family: var(--font-family-base) !important;\n\tfont-weight: 400;\n\tfont-size: 16px;\n\tline-height: 19px;\n\tcolor: var(--secondary-oscuro);\n\ttext-align: center;\n\tmax-width: 300px;\n\tmargin: 10px auto;\n}\n\n/* ===== Divider line (\"o continuar con\") ===== */\n.lineThrough {\n\tfont-size: 20px;\n\tfont-family: var(--font-family-base);\n\tline-height: 23px;\n\tfont-weight: 400;\n\ttext-align: center;\n\tposition: relative;\n\tmargin: 12px 0 12px;\n}\n\n.linetext {\n\tcolor: var(--secondary-oscuro);\n\tfont-size: 14px;\n\tfont-family: var(--font-family-base);\n\tline-height: 23px;\n\tposition: relative;\n\tdisplay: inline-block;\n\tbackground: #FFFFFF;\n\tpadding: 0 10px;\n\tz-index: 1;\n}\n\n.lineThrough::before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 0;\n\tright: 0;\n\theight: 1px;\n\tbackground-color: #8E8E93;\n\tz-index: 0;\n}\n\n/* ===== Bottom links ===== */\n.linkText {\n\tfont-size: 14px;\n\tfont-family: var(--font-family-base);\n\tline-height: 23px;\n\tfont-weight: 400;\n\tdisplay: flex;\n\tgap: 8px;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-bottom: 0px;\n\tmargin-top: 12px;\n\tcolor: var(--secondary-oscuro);\n}\n\n.modalCaptionLink,\n.modalCaptionLink:hover,\n.modalCaptionLink:focus,\n.modalCaptionLink:active {\n\tcolor: var(--color-gradient-top);\n\tfont-size: 14px;\n\tfont-family: var(--font-family-base);\n\tfont-weight: 700;\n\tcursor: pointer;\n\ttext-decoration: none;\n}\n\n/* ===== Bottom app banner ===== */\n.appBanner {\n\twidth: 100%;\n\tmax-width: 1199px;\n\tmargin: 0px auto 40px;\n\tbackground: var(--color-gradient-top);\n\tborder: 1px solid var(--color-gradient-top);\n\tborder-radius: 19px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: clamp(12px, 2vh, 26px) 34px;\n\tbox-sizing: border-box;\n\tposition: relative;\n\toverflow: visible;\n\tmin-height: clamp(74px, 8vh, 118px);\n\tflex-shrink: 0;\n}\n\n.appBannerLeft {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 24px;\n\tposition: relative;\n\tz-index: 2;\n\tpadding-left: clamp(150px, 12vw, 185px);\n}\n\n.phoneMockup {\n\tposition: absolute;\n\tleft: 0px;\n\tbottom: -35px;\n\theight: clamp(180px, 13vh, 168px);\n\twidth: 135px;\n\tobject-fit: cover;\n\tobject-position: top;\n\tfilter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.15));\n\tborder-radius: 30px 30px 0px 0px;\n\tclip-path: inset(0px 4px 0px 4px);\n}\n\n.appBannerTextGroup {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.appBannerTitle {\n\tfont-family: var(--font-family-base);\n\tfont-weight: 700;\n\tfont-size: clamp(16px, 1.35vw, 24px);\n\tline-height: clamp(19px, 1.6vw, 28px);\n\tcolor: #FFFFFF;\n\tmargin: 0 0 4px;\n}\n\n.appBannerDesc {\n\tfont-family: var(--font-family-base);\n\tfont-weight: 400;\n\tfont-size: clamp(12px, 1vw, 16px);\n\tline-height: clamp(15px, 1.2vw, 19px);\n\tcolor: #FFFFFF;\n\tmargin: 0;\n\tmax-width: 300px;\n}\n\n.appBannerRight {\n\tdisplay: flex;\n\tgap: 16px;\n\talign-items: center;\n\tz-index: 2;\n}\n\n.storeIcon {\n\theight: clamp(47px, 3.4vh, 47px);\n\twidth: auto;\n\tobject-fit: contain;\n\tcursor: pointer;\n\ttransition: opacity 0.2s ease;\n}\n\n.storeIcon:hover {\n\topacity: 0.85;\n}\n\n/* ===== Hidden / unused classes (kept for compat) ===== */\n.logoTopContainer {\n\tdisplay: none;\n}\n\n.logoTop {\n\tdisplay: none;\n}\n\n.contentWrapper {\n\tdisplay: none;\n}\n\n.welcomeSection {\n\tdisplay: none;\n}\n\n.logoImage {\n\tdisplay: none;\n}\n\n.appStoreSection {\n\tdisplay: none;\n}\n\n.appStoreText {\n\tdisplay: none;\n}\n\n.appStoreIcons {\n\tdisplay: none;\n}\n\n.iconPosition {\n\tposition: absolute;\n\ttop: 15px;\n\tright: 10px;\n}\n\n/* ===== Responsive ===== */\n@media screen and (max-width: 1024px) {\n\t.pageWrapper {\n\t\theight: auto;\n\t\tmin-height: 100vh;\n\t\tmin-height: 100dvh;\n\t\tmax-height: none;\n\t}\n\n\t.mainContent {\n\t\tflex-direction: column;\n\t\tpadding: 60px 16px 20px;\n\t\tgap: 24px;\n\t}\n\n\t.leftColumn {\n\t\tmax-width: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.welcomeSubtitle {\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\n\t.featuresList {\n\t\talign-items: center;\n\t}\n\n\t.featureItem {\n\t\ttext-align: left;\n\t}\n\n\t.rightColumn {\n\t\twidth: 100%;\n\t\tjustify-content: center;\n\t}\n\n\t.appBanner {\n\t\tmargin-left: 16px;\n\t\tmargin-right: 16px;\n\t\twidth: calc(100% - 32px);\n\t\tmax-width: calc(100% - 32px);\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.primaryLogo {\n\t\tleft: 14px;\n\t\ttop: 14px;\n\t\theight: 30px;\n\t}\n\n\t.mainContent {\n\t\tpadding: 55px 12px 16px;\n\t\tgap: 20px;\n\t}\n\n\t.welcomeTitle {\n\t\tfont-size: 28px;\n\t}\n\n\t.welcomeSubtitle {\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t}\n\n\t.featuresList {\n\t\tgap: 12px;\n\t\tmargin-bottom: 16px;\n\t}\n\n\t.root {\n\t\twidth: 100%;\n\t\tmax-width: 480px;\n\t\tpadding: 20px 24px 18px;\n\t\tborder-radius: 24px;\n\t}\n\n\t.appBanner {\n\t\tflex-direction: column;\n\t\ttext-align: center;\n\t\tpadding: 14px 14px 120px;\n\t\tmargin-left: 12px;\n\t\tmargin-right: 12px;\n\t\twidth: calc(100% - 24px);\n\t\tmax-width: calc(100% - 24px);\n\t}\n\n\t.appBannerLeft {\n\t\tflex-direction: column;\n\t\tgap: 8px;\n\t\tpadding-left: 0;\n\t}\n\n\t.phoneMockup {\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\tbottom: -6px;\n\t\theight: 112px;\n\t\tmargin-top: 0;\n\t\tmargin-bottom: 0;\n\t}\n\n\t.appBannerRight {\n\t\tmargin-top: 10px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrapper": `LoginModal-pageWrapper-nhhTe`,
	"primaryLogo": `LoginModal-primaryLogo-lRECJ`,
	"mainContent": `LoginModal-mainContent-uqB4E`,
	"leftColumn": `LoginModal-leftColumn-kcDXi`,
	"welcomeTitle": `LoginModal-welcomeTitle-UMxe0`,
	"welcomeTitleAccent": `LoginModal-welcomeTitleAccent-dig_w`,
	"welcomeSubtitle": `LoginModal-welcomeSubtitle-Y1CHY`,
	"featuresList": `LoginModal-featuresList-kgvFN`,
	"featureItem": `LoginModal-featureItem-AvQWd`,
	"featureIconCircle": `LoginModal-featureIconCircle-LbFl6`,
	"featureTextGroup": `LoginModal-featureTextGroup-SBMV8`,
	"featureTitle": `LoginModal-featureTitle-dy74p`,
	"featureDesc": `LoginModal-featureDesc-Ovj2C`,
	"rightColumn": `LoginModal-rightColumn-MtBGT`,
	"root": `LoginModal-root-QOU0j`,
	"closeBtn": `LoginModal-closeBtn-LBjEU`,
	"cardHeader": `LoginModal-cardHeader-XmZ3u`,
	"cardIconWrapper": `LoginModal-cardIconWrapper-nWohp`,
	"cardTitle": `LoginModal-cardTitle-gv9Lk`,
	"cardSubtitle": `LoginModal-cardSubtitle-xKZe6`,
	"lineThrough": `LoginModal-lineThrough-GwwzN`,
	"linetext": `LoginModal-linetext-yiXO4`,
	"linkText": `LoginModal-linkText-I9vtK`,
	"modalCaptionLink": `LoginModal-modalCaptionLink-SpyYZ`,
	"appBanner": `LoginModal-appBanner-ulzRT`,
	"appBannerLeft": `LoginModal-appBannerLeft-UZPtN`,
	"phoneMockup": `LoginModal-phoneMockup-BJiz_`,
	"appBannerTextGroup": `LoginModal-appBannerTextGroup-HqlyK`,
	"appBannerTitle": `LoginModal-appBannerTitle-M8wNT`,
	"appBannerDesc": `LoginModal-appBannerDesc-PyuJx`,
	"appBannerRight": `LoginModal-appBannerRight-jFd_u`,
	"storeIcon": `LoginModal-storeIcon-KUVO9`,
	"logoTopContainer": `LoginModal-logoTopContainer-whXsN`,
	"logoTop": `LoginModal-logoTop-m7U7j`,
	"contentWrapper": `LoginModal-contentWrapper-G37eS`,
	"welcomeSection": `LoginModal-welcomeSection-SMPpy`,
	"logoImage": `LoginModal-logoImage-suN63`,
	"appStoreSection": `LoginModal-appStoreSection-blys4`,
	"appStoreText": `LoginModal-appStoreText-GrYOV`,
	"appStoreIcons": `LoginModal-appStoreIcons-m319z`,
	"iconPosition": `LoginModal-iconPosition-gTHqL`
};
module.exports = ___CSS_LOADER_EXPORT___;
